import { GroupBase, GroupHeadingProps } from 'react-select';

import classNames from 'classnames';

import cssClasses from './group-heading.module.scss';

function GroupHeading<Option, IsMulti extends boolean, Group extends GroupBase<Option>>({
  children,
  selectProps: { allowClickableHeader = false },
}: GroupHeadingProps<Option, IsMulti, Group>) {
  return (
    <div className={classNames(cssClasses.groupHeading, { [cssClasses.header]: allowClickableHeader })}>{children}</div>
  );
}

export default GroupHeading;
